export default {
    InflationProtectedStablecoin : "Inflation Protected Stablecoin",
    ReservesYieldManagedbyPikuDAO : 'Reserves & Yield Managed by PikuDAO',
    ExplorePIKU : 'Explore PIKU',
    LearnMore : 'Learn More',
    Overview : 'Overview',
    Docs : 'Docs',
    Community : 'Community',
    Governance : 'Governance',
    Claim: 'Claim',
    ConnectWallet : 'Connect Wallet',
    Disconnect: 'Disconnect',
    Resources : 'Resources',
    Whitepaper : 'Whitepaper',
    Audits : 'Audits',
    Events : 'Events',
    Contracts : 'Contracts',
    BugBounty : 'Bug Bounty',
    FAQ : 'FAQ',
    DeveloperDocs : 'Developer Docs',
    News : 'News',
    Github : 'Github',
    JointheCommunity : 'Join the Community',
    joindesc : 'A community of PIKU token holders are responsible for guiding the future direction of Piku through the Piku DAO.',
    Forum : 'Forum',
    Vote : 'Vote',
    Discord : 'Discord',
    Telegram : 'Telegram',
    LatestNews : 'Latest News',
    SeeAll : 'See All',
    CompleteKYC : ' Complete KYC',
    Verifyyouridentity : 'Verify your identity',
    identitydesc : 'Unlock all features of Piku by completing your account verification',
    VerifyNow : 'Verify Now',
    Mint : 'Mint',
    Redeem : 'Redeem',
    Chooseamountandtokentomint : 'Choose amount and token to mint',
    Close : 'Close',
    Youvesuccessfullyredeemed : 'You’ve successfully redeemed',
    successdesc : ' Your transaction has been confirmed on the blockchain. Your vault are now available in your wallet.',
    YourTransactionHash : 'Your Transaction Hash',
    Youvesuccessfullyminted :' You’ve successfully minted',
    Waitingforconfirmations : 'Waiting for confirmations',
    Yourtransactionhasbeensent : 'Your transaction has been sent.',
    Confirmthistransactioninyourwallet : 'Confirm this transaction in your wallet.',
    ReserveWalletAddress : 'Reserve Wallet Address',
    ReserveBackingDistribution : 'Reserve Backing Distribution',
    Balances:'Balances',
    PikuGRewards:'PikuG Rewards',
    MyDAOActivity:'My DAO Activity',
    Delegation:'Delegation',
    Stats:'Stats',
    LockPikuGforvePikuG:'Lock PikuG for vePikuG',
    ASSET:'ASSET',
    EARNED:'EARNED',
    Delegates:'Delegates',
    TotalvePikuGDelegated:'Total vePikuG Delegated',
    LockPikuGforvePikuG : 'Lock PikuG for vePikuG'

 
}